//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import cmBlank from '@/components/cmBlank';
import cmLoadmore from '@/components/cmLoadmore.vue'
import wx from 'weixin-js-sdk'; 

export default {
     components: {
        cmBlank,cmLoadmore
    },
    data(){
        return {
            i:0,
            keyword:'',
            blankShow:false,
            loadStatus:false,
            loadmoreText:'正在加载。。。',
            busy:false,
            types:[],
            list:[],
            where:[],
            hasNext:0,
            pageFlag:2,
            lastId:0,
            isActive:0,

        }
    },
    mounted(){
        this.config();
    },
    methods: {
        select(i){
            // this.where = [];
            this.isActive = i;
            this.lastId = 0;
            this.pageFlag = 2;
            this.list = [];
            this.hasNext = 0;
            this.loadmore();
        },
        openMap(cid){
            this.$router.push({name:'openMap',params:{id:cid}})
        },
        waitPickupInfo(cid){
            this.$router.push({name:'waitPickupInfo',params:{cid:cid,i:this.i,type:this.isActive,order_type:3}})
        },
        copy(val){
            this.$func.copy(val,event);
        },
        search(){
            this.list = [];
            this.lastId = 0;
            this.hasNext = 0;
            this.getList();
        },
        getList(){
            this.$api.waitPickup({last_id:this.lastId,page_flag:this.pageFlag,keyword:this.keyword,i:this.i,type:this.isActive,order_type:3}).then((res)=>{
                if(res){
                    if(!this.lastId){
                        this.blankShow = res.data.length > 0 ? false : true;
                    }
                    this.hasNext = res.hasNext;
                    this.lastId = res.lastId;
                    res.data.forEach((item)=>{
                        this.list.push(item);
                    });
                }
            })  
        },
        loadmore(){
            if(this.lastId > 0 && !this.hasNext){
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。'
                return ;
            }
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            this.getList();
            setTimeout(()=>{
                if(this.blankShow){
                    this.busy = true;
                    this.loadStatus = false;
                    this.loadmoreText = '没有更多了。。。'
                }else{
                    if(this.hasNext > 0){
                        this.loadStatus = false;
                        this.busy = false;
                    }else{
                        this.busy = true;
                        this.loadStatus = true;
                        this.loadmoreText = '没有更多了。。。'
                    }
                }
            },1500)
        },
        config(){
            let url = (window.location.href).split('#');
            if(url[0].indexOf('?') != '-1'){
                url = url[0].split('?');
            }
            this.$api.wxSign({url:url[0]}).then((res)=>{
                if(res){
                    wx.config({
                        debug: false, 
                        appId: res.data.appId,
                        timestamp: res.data.timestamp,
                        nonceStr: res.data.nonceStr,
                        signature:res.data.signature,
                        jsApiList: [
                            "openLocation"
                        ]
                    });
                }
            })
        },
        getInfo(id){
            this.$api.getCommunity({id:id}).then((res)=>{
                if(res){
                // this.info = res.data;
                wx.openLocation({
                    latitude: Number(res.data.lat), // 纬度，浮点数，范围为90 ~ -90
                    longitude: Number(res.data.lng), // 经度，浮点数，范围为180 ~ -180。
                    name: res.data.name, // 位置名
                    address: res.data.province+' '+res.data.city+' '+res.data.district+' '+res.data.address, // 地址详情说明
                    scale: 15, // 地图缩放级别,整型值,范围从1~28。默认为最大
                    infoUrl: '' // 在查看位置界面底部显示的超链接,可点击跳转
                });
                }
            })  
        }
    },
}



// WEBPACK FOOTER //
// ./src/pages/waitPickupGoods.vue